import React from 'react'
import { ButtonType } from '../../../components/GenericButton/styles'
import { Typography } from '@mui/material'
import { grey } from '../../../colors'
import { useTheme } from '@mui/material/styles'
import DefaultModalActions from '../../../components/GenericModal/DefaultModalActions'
import { type ITerm } from '../../../models/Term'
import { type ApiError } from '../../../models/Common'
import { notification } from '../../../components/Notifications'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { TermsManager } from '../../../APIManager'

interface DeleteTermsProps {
  selectedRow?: ITerm
  handleCloseModal?: () => void
  showErrorModal?: () => void
  setErrorMessage?: (arg: string) => void
}

const DeleteTerms: React.FC<DeleteTermsProps> = ({ selectedRow, handleCloseModal, showErrorModal, setErrorMessage }) => {
  const theme = useTheme()
  const queryClient = useQueryClient()

  const { mutateAsync: deleteTerm, isPending: isDeleteLoading } = useMutation({
    mutationFn: TermsManager.deleteTerm,
    onSuccess: (res) => {
      void queryClient.invalidateQueries({ queryKey: ['getGlobalTermsListApi'] })
      notification('Successfully deleted', { variant: 'success', subTitle: res.data.message })
      handleCloseModal?.()
    },
    onError: (error) => {
      const customError = error as ApiError
      if (customError && customError.status === 422) {
        setErrorMessage?.(customError.message)
        showErrorModal?.()
      }
    },
    meta: { silent: true }
  })

  const handleDelete = async (): Promise<void> => {
    if (selectedRow) {
      try {
        await deleteTerm(selectedRow.termId)
      } catch (error) {
        console.log(error)
      }
    }
  }

  return (
    <>
      <Typography fontSize='14px' lineHeight={theme.spacing(5)} color={grey[850]}>
        You will not be able to recover this Term. All references to it will be deleted.
      </Typography>
      <DefaultModalActions
        confirmButtonProps={{
          onClick: handleDelete,
          text: 'Delete',
          loading: isDeleteLoading,
          buttonType: ButtonType.Destructive
        }}
        destructiveButtonProps={{
          onClick: handleCloseModal
        }}
      />
    </>

  )
}

export default DeleteTerms
